/**
 * Check and return if an object is empty
 *
 * @param {Object} obj
 * @returns {Boolean}
 */
const isEmpty = obj => {
  return obj ? Object.keys(obj).length === 0 : true;
};

export default isEmpty;
